// export const LOGOUT_TIME = 2*7*24*60*60*1000;

export const LOGOUT_TIME = 24*60*60*1000;
export const SECOND_AUTH_WINDOW = 30*60*1000;

export const SECURITY_QUESTIONS = [
	'Who was your favorite elementary school teacher?',
	'What is your mother\'s maiden name?',
	'What is the name of your first pet?',
];